import Controller from "csi/action/Controller";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";

const DataSheetItemsPasteAction = declare(Controller, {

	/**
	 * @override
	 * Add paste-data param to server operation
	 */
	toWriterRequest() {
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("Data", xml.ATTR_STRING, this.getFormData().getFieldInitialValue("Data"));
		return call;
	},
});

export = DataSheetItemsPasteAction;